module.exports = __webpack_public_path__ + "static/media/peon.cdc20026.png";